import React from 'react';
import Main from 'layouts/Main';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from 'config/theme';
import { Provider } from 'react-redux';
import store from './store';
import { config } from 'config/fontawesome';
config();

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <HashRouter>
        <Provider store={store}>
          <Main />
        </Provider>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;
